import React, { Component } from 'react';
import cordBlack from '../../images/cords/black.png';
import cordNeonPink from '../../images/cords/neon-pink.png';
import cordRedYellow from '../../images/cords/red-yellow.png';
// import cordWhite from '../../images/cords/white.png';
import cordRudi from '../../images/cords/rudi.png';
import cordGreyBlack from '../../images/cords/grey-black.png';
import cordTurquoise from '../../images/cords/turquoise.png';
import cordPurpleBlack from '../../images/cords/purple-black.png';
import cordOrange from '../../images/cords/orange.png';
import cordOle from '../../images/cords/ole.png';
import cordBrunhilde from '../../images/cords/brunhilde.png';
import cordSissi from '../../images/cords/sissi.png';
import cordFranz from '../../images/cords/franz.png';
import cordLorelei from '../../images/cords/lorelei.png';
import cordAlfons from '../../images/cords/alfons.png';
import cordMathilde from '../../images/cords/mathilde.png';
import cordHerbert from '../../images/cords/herbert.png';
import cordSibylle from '../../images/cords/sibylle.png';
import cordPaulina from '../../images/cords/paulina.png';
import cordDorothea from '../../images/cords/dorothea.png';
import cordFritz from '../../images/cords/fritz.png';
import cordEster from '../../images/cords/ester.png';
import cordHans from '../../images/cords/hans.png';
import cordJosef from '../../images/cords/josef.png';

class ActiveCord extends Component {
	render() {
		return (
			<div className="active-cord">
				{this.props.activeCord === 0 &&
					<img src={cordBlack} alt="" />
				}

				{this.props.activeCord === 1 &&
					<img src={cordNeonPink} alt="" />
				}

				{this.props.activeCord === 2 &&
					<img src={cordRedYellow} alt="" />
				}

				{this.props.activeCord === 3 &&
					<img src={cordRudi} alt="" />
				}

				{this.props.activeCord === 4 &&
					<img src={cordGreyBlack} alt="" />
				}

				{this.props.activeCord === 5 &&
					<img src={cordTurquoise} alt="" />
				}

				{this.props.activeCord === 6 &&
					<img src={cordPurpleBlack} alt="" />
				}

				{this.props.activeCord === 7 &&
					<img src={cordOrange} alt="" />
				}

				{this.props.activeCord === 8 &&
					<img src={cordOle} alt="" />
				}

				{this.props.activeCord === 9 &&
					<img src={cordBrunhilde} alt="" />
				}

				{this.props.activeCord === 10 &&
					<img src={cordSissi} alt="" />
				}

				{this.props.activeCord === 11 &&
					<img src={cordFranz} alt="" />
				}

				{this.props.activeCord === 12 &&
					<img src={cordLorelei} alt="" />
				}

				{this.props.activeCord === 13 &&
					<img src={cordAlfons} alt="" />
				}

				{this.props.activeCord === 14 &&
					<img src={cordMathilde} alt="" />
				}

				{this.props.activeCord === 15 &&
					<img src={cordHerbert} alt="" />
				}

				{this.props.activeCord === 16 &&
					<img src={cordSibylle} alt="" />
				}

				{this.props.activeCord === 17 &&
					<img src={cordPaulina} alt="" />
				}

				{this.props.activeCord === 18 &&
					<img src={cordDorothea} alt="" />
				}

				{this.props.activeCord === 19 &&
					<img src={cordFritz} alt="" />
				}

				{this.props.activeCord === 20 &&
					<img src={cordJosef} alt="" />
				}

				{this.props.activeCord === 21 &&
					<img src={cordHans} alt="" />
				}

				{this.props.activeCord === 22 &&
					<img src={cordEster} alt="" />
				}
				
			</div>
		)
	}
}
export default ActiveCord;